import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Modal } from 'react-bootstrap'

import { LoadingSpinner } from '../../components'
import {
  fetchGradebookData,
  updateModal,
  fetchModalBody,
  updateDimensions,
  updateScoreFormat,
  startDownload,
} from '../actions'

import ViewOptions from './ViewOptions'
import GradebookTable from './GradebookTable'

export class Gradebook extends React.Component {
  constructor() {
    super()
    this.retrieveData = this.retrieveData.bind(this)
  }

  static propTypes = {
    filters: PropTypes.object,
    loading: PropTypes.bool,
    limit: PropTypes.number,
    page: PropTypes.number,
    coursenum: PropTypes.string,
    modal: PropTypes.object,
    isPercentFormat: PropTypes.bool,
    updateModal: PropTypes.func,
    fetchModalBody: PropTypes.func,
    updateDimensions: PropTypes.func,
    updateScoreFormat: PropTypes.func,
    fetchGradebookData: PropTypes.func,
    startDownload: PropTypes.func,
    showAccountingButton: PropTypes.bool,
    isCanvasCourse: PropTypes.bool,
  }

  componentDidMount() {
    this.retrieveData()
    window.addEventListener('resize', this.props.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.props.updateDimensions)
  }

  retrieveData(page = 1) {
    let data = {
      ...this.props.filters,
      limit: this.props.limit,
      page,
    }
    this.props.fetchGradebookData(data)
  }

  render() {
    const {
      loading,
      modal,
      isPercentFormat,
      filters,
      updateScoreFormat,
      updateModal,
      fetchModalBody,
      startDownload,
      page,
      limit,
      coursenum,
      showAccountingButton,
    } = this.props

    let mainContent = loading ? (
      <LoadingSpinner
        style={{ fontSize: '50px' }}
        outerClass={'spinner-holder'}
      />
    ) : (
      <GradebookTable
        retrieveData={this.retrieveData}
        isPercentFormat={isPercentFormat}
        updateModal={updateModal}
        fetchModalBody={fetchModalBody}
        page={page}
        limit={limit}
        coursenum={coursenum}
      />
    )

    let modalBody =
      modal.modalBody != null ? (
        <div dangerouslySetInnerHTML={{ __html: modal.modalBody }} />
      ) : (
        <LoadingSpinner style={{ fontSize: '50px' }} />
      )

    return (
      <div>
        <ViewOptions
          isPercentFormat={isPercentFormat}
          filters={filters}
          updateScoreFormat={updateScoreFormat}
          startDownload={startDownload}
          showAccountingButton={showAccountingButton}
          isCanvasCourse={this.props.isCanvasCourse}
        />
        <h1 className="me-page-title">Gradebook</h1>
        <div className="card-myed">{mainContent}</div>
        <Modal
          show={modal.showModal}
          onHide={() => updateModal({ showModal: false })}
        >
          <Modal.Header>
            <Modal.Title>{modal.selectedActivity.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modalBody}</Modal.Body>
          <Modal.Footer>
            <Button onClick={() => updateModal({ showModal: false })}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    loading: state.loading,
    limit: state.limit,
    page: state.page,
    coursenum: state.coursenum,
    modal: state.modal,
    isPercentFormat: state.isPercentFormat,
    isCanvasCourse: state.isCanvasCourse,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateModal: modalState => {
      dispatch(updateModal(modalState))
    },
    fetchModalBody: (actId, studentId) => {
      dispatch(fetchModalBody(actId, studentId))
    },
    fetchGradebookData: data => {
      dispatch(fetchGradebookData(data))
    },
    updateDimensions: data => {
      dispatch(updateDimensions(data))
    },
    updateScoreFormat: toggle => {
      dispatch(updateScoreFormat(toggle))
    },
    startDownload: (data, filters) => {
      dispatch(startDownload(data, filters))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Gradebook)
